module.exports = __webpack_public_path__ + "img/popup-game-sucai.e99f6529.png";